export default __webpack_public_path__ + "static/lb-3-35805354f89b1f3351834a4da2e1244c.jpeg";